import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/Ver_preguntas.css';
import { useUserPermissions } from './UserContext';

const Ver_preguntas = (props) => {
    const location = useLocation();
    console.log('location.state:', location.state);
    const { preguntas = [], selected, posicion, aciertos, fallos } = location.state || {}; // Accede a los datos pasados
    const userPermissions = useUserPermissions();
    const username = userPermissions?.username || '';
    const ruta = userPermissions?.ruta || '';
    const email = userPermissions?.email || '';
    const [currentIndex, setCurrentIndex] = useState(posicion);
    const [contador, setContador] = useState(aciertos);
    const [contadorFallos, setContadorFallos] = useState(fallos);
    const [respuestaSeleccionada, setRespuestaSeleccionada] = useState('');
    const [botonDesactivado, setBotonDesactivado] = useState(false);
    const [botonDesactivado2, setBotonDesactivado2] = useState(true);
    const [primeraVez, setPrimeraVez] = useState(false);
    const [opcionesDesordenadas, setOpcionesDesordenadas] = useState([]);
    const [letrasDesordenadas, setLetrasDesordenadas] = useState([]);
    const [messageType, setMessageType] = useState('');
    const [message, setMessage] = useState('');
    const [respuestaCorrecta, setRespuestaCorrecta] = useState(null); // Guardará la opción correcta para pintar en verde
    const [respuestaIncorrecta, setRespuestaIncorrecta] = useState(null); // Guardará la opción incorrecta para pintar en rojo

    const seleccionarRespuesta = (valor) => {
        setRespuestaSeleccionada(valor);
    
        // Verificamos si la opción seleccionada es correcta
        setRespuestaCorrecta(preguntas[currentIndex]?.respuesta);
        if (valor !== preguntas[currentIndex]?.respuesta) {
            setRespuestaIncorrecta(valor);
        }
    };

    const handleSubmit = async (e) => {
        //e.preventDefault();

        console.log(username);
        // Crea un objeto con los datos del formulario
        const formData = {
            username,
            email,
            selected,
            contador,
            contadorFallos
        };

        try {
            const response = await fetch(ruta + '/actualizar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error('Error en la solicitud');
            }

            const result = await response.json();
            console.log('Respuesta de la API:', result);
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
        }
    };
    // Función para barajar un array
    const shuffle = (array1, array2) => {
        for (let i = array1.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array1[i], array1[j]] = [array1[j], array1[i]];
            [array2[i], array2[j]] = [array2[j], array2[i]];
        }
    };

    // Función para mostrar una pregunta
    const mostrarPregunta = (index) => {
        if (preguntas.length === 0) return null;
        const pregunta = preguntas[index];
        const letras = ['a', 'b', 'c', 'd'];
        console.log(pregunta);
        const opciones = [
            pregunta.opcion_a,
            pregunta.opcion_b,
            pregunta.opcion_c,
            pregunta.opcion_d
        ];

        if (!primeraVez) {
            // Desordenamos las opciones y letras solo la primera vez
            const opcionesCopia = [...opciones];
            const letrasCopia = [...letras];
            shuffle(opcionesCopia, letrasCopia);
            setOpcionesDesordenadas(opcionesCopia);
            setLetrasDesordenadas(letrasCopia);
            setPrimeraVez(true);
        }

        return (
            <div className='col-12'>
                <div className='text-center'>
                    <p className='boldPalabras'>Pregunta {pregunta.numero} de {pregunta.examen}</p>
                </div>
                <br></br>
                <p>{pregunta.pregunta}</p>
                <br></br>
                {opcionesDesordenadas.map((opcion, i) => (
                    <div className="row col-12" key={i}>
                        <input className='col-2 radiobutton'
                            type="radio"
                            name="respuesta"
                            id={letrasDesordenadas[i]}
                            value={letrasDesordenadas[i]}
                            onChange={(e) => setRespuestaSeleccionada(e.target.value)}
                            checked={respuestaSeleccionada === letrasDesordenadas[i]} // Mantener selección
                        />
                        <label
                            className={`col-10 opcion ${respuestaCorrecta === letrasDesordenadas[i] ? 'correcta' :
                                    respuestaIncorrecta === letrasDesordenadas[i] ? 'incorrecta' : ''
                                }`}
                            htmlFor={letrasDesordenadas[i]}
                        >
                            {letrasDesordenadas[i]}) {opcion}
                        </label>
                    </div>
                ))}
            </div>
        );
    };

    // Función para manejar la verificación de respuesta
    const verificarRespuesta = (e) => {

        seleccionarRespuesta(respuestaSeleccionada);
        if (respuestaSeleccionada === preguntas[currentIndex]?.respuesta) {
            //alert('¡Respuesta correcta!');
            setContador(contador + 1);
        } else {
            setContadorFallos(contadorFallos + 1);
            //alert('Respuesta incorrecta. La respuesta correcta es: ' + preguntas[currentIndex]?.respuesta);
        }
        setBotonDesactivado(true);
        setBotonDesactivado2(false);
    };

    // Función para manejar el avance a la siguiente pregunta
    const siguientePregunta = () => {
        setRespuestaCorrecta(null);
        setRespuestaIncorrecta(null);
        if (currentIndex < preguntas.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setRespuestaSeleccionada('');
            setPrimeraVez(false); // Permitir desordenar de nuevo para la próxima pregunta
            setBotonDesactivado(false);
            setBotonDesactivado2(true);
            setMessage('');
            setMessageType('');
        } else {
            setMessage('No hay más preguntas.');
            setMessageType('attention');
            eliminarOrdenGuardado();
            //alert('No hay más preguntas.');
        }
        handleSubmit();
    };

    const eliminarOrdenGuardado = async () => {
        try {
            const response = await fetch('/borrado_orden_guardado', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, email, seleccion: selected }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Registro eliminado:', data.message); // Confirmación de eliminación
            } else {
                console.error('Error al eliminar el registro');
            }
        } catch (err) {
            console.error('Error en la conexión:', err);
        }
    };

    return (
        <div className='contenedor_principal_per col-12 col-md-12'>
            <div className='preguntas col-11 col-md-8'>
                <div className='col-11 col-md-8'>
                    <div className='examenPregunta'>
                        <h1 className='boldPalabras'>{selected}</h1>
                        {mostrarPregunta(currentIndex)}
                    </div>
                    <p></p>
                    <div className='botones col-10'>
                        <button className="botonVerificar col-5" onClick={verificarRespuesta} disabled={botonDesactivado}>Verificar</button>
                        <button className="botonSiguiente col-5" onClick={siguientePregunta} disabled={botonDesactivado2}>Siguiente</button>
                    </div>
                    <p></p>
                    <div className='verification2'>
                        <p className='aciertos'>Aciertos: {contador}/{preguntas.length}</p>
                    </div>
                    <p></p>
                    <div className={`messageBox ${messageType}`}>{message}</div> {/* Mostrar el mensaje */}
                </div>
            </div>
        </div>
    );
}

export default Ver_preguntas;